<template>
<div class="vx-card header-border-b">
    <div class="vx-card__header pb-2">
        <div class="vx-card__title">
            <h4>Payment Information</h4>
        </div>
    </div>
    <div class="vx-card__collapsible-content vs-con-loading__container">
        <div class="vx-card__body">
            <div class="vx-row">
                <div class="vx-col sm:w-6/12 sm:ml-auto sm:mr-auto w-full">
                    <div class="vx-row">                        
                        <div class="vx-col w-full">
                            <div class="vx-row mb-6">
                                <div class="vx-col w-full">
                                    <span>Fee Amount</span>
                                </div>
                                <div class="vx-col w-full">
                                    <span class="block vs-input--view custome-padding">$ 40.00</span>
                                </div>
                            </div>
                        </div>  
                    </div>
                    <div id="sq-ccbox">
                        <!--
                        You should replace the action attribute of the form with the path of
                        the URL you want to POST the nonce to (for example, "/process-card")
                        -->
                        <form id="nonce-form" novalidate >
                            <div id="card-tainer">        
                                <div class="cardfields card-number" :id="'-sq-card-number'">o</div>
                                <div class="cardfields expiration-date" :id="'-sq-expiration-date'">e</div>
                                <div class="cardfields cvv" :id="'-sq-cvv'">e</div>
                                <div class="cardfields postal-code" :id="'-sq-postal-code'">e</div>
                            </div>
                            <div class="errorbox">
                                <div class="error" v-for="error in errors" :key="error.message">
                                    {{error}}
                                </div>
                            </div>

                        </form>
                    </div>
                    <button @click="requestCardNonce($event)" class="productPurchase payButton">$ 40 Pay</button>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import Prospect from '@/js/applyRental.js'
import router from './../../../router.js'

export default {
  name: 'paymentForm',
  data () {
    return {
      formData: {
        cardName: 'test',
        cardNumber: '',
        cardMonth: '',
        cardYear: '',
        cardCvv: ''
      },
      prospectId: null,
      errors: [],
      masterpass: false,
      applePay: false
    }
  },
  watch: {
    showPaymentForm () {
      this.paymentForm.build()
    }
  },
  created () {
    this.mounted1()
    this.paymentForm.build()
    console.log('this', this)
  },
  props: {
    showPaymentForm: Boolean,
    id: Number
  },
  components: {
  },
  methods: {
    requestCardNonce (event) {
      this.errors = []
      event.preventDefault()

      this.paymentForm.requestCardNonce()
    },
    paymentCompleted (data) {
      this.$vs.loading.close()
      router.go(-1)
      this.$vs.dialog({type: 'alert', color: 'success', title: 'Payment', text: data.return_message, accept: null})
    },
    paymentNotCompleted (message) {
      console.log('message123', message)
      this.$vs.dialog({type: 'alert', color: 'danger', title: 'Payment', text: message, accept: null})
    },
    mounted1 () {
      //prod const locationId1 = 'LWP151CWEDXZ0'
      const locationId1 = 'LFCKE50DGHPMY'
      const applicationId1 = 'sandbox-sq0idb-y0PH6_lWMz8yK6a0XXGDWg'
      // prod const applicationId1 = 'sq0idp-Kr74A0ACPYrK1VdxcZL07g'
      const that = this
      this.paymentForm = new SqPaymentForm({
        autoBuild: true,
        applicationId: applicationId1,
        locationId: locationId1,
        inputClass: 'sq-input',
        // Initialize the payment form elements

        // Customize the CSS for SqPaymentForm iframe elements
        inputStyles: [
          {
            fontSize: '.9em'
          }
        ],

        // Initialize the credit card placeholders
        cardNumber: {
          elementId: '-sq-card-number',
          placeholder: 'Card number'
        },
        cvv: {
          elementId: '-sq-cvv',
          placeholder: 'CVV'
        },
        expirationDate: {
          elementId: '-sq-expiration-date',
          placeholder: 'MM / YY'
        },
        postalCode: {
          elementId: '-sq-postal-code',
          placeholder: 'Zip Code'
        },

        // SqPaymentForm callback functions
        callbacks: {
        /*
            * callback function: methodsSupported
            * Triggered when: the page is loaded.
            */
          methodsSupported (methods) {
            // Only show the button if Apple Pay for Web is enabled
            // Otherwise, display the wallet not enabled message.
            that.applePay = methods.applePay
            that.masterpass = methods.masterpass
          },

          /*
            * Digital Wallet related functions
            */
          createPaymentRequest () {
            const paymentRequestJson = null
            /* ADD CODE TO SET/CREATE paymentRequestJson */
            return paymentRequestJson
          },
          validateShippingContact () {
            const validationErrorObj = null
            /* ADD CODE TO SET validationErrorObj IF ERRORS ARE FOUND */
            return validationErrorObj
          },

          /*
            * callback function: cardNonceResponseReceived
            * Triggered when: SqPaymentForm completes a card nonce request
            */
          cardNonceResponseReceived (errors1, nonce) {
            if (errors1) {
              errors1.forEach(function (error) {
                that.errors.push(error.message)
              })
              return
            }
            const data = {
              source_id: nonce
            }
            that.$vs.loading()
            Prospect.makePayment(that, that.prospectId, data)
          },
          /*
            * callback function: paymentFormLoaded
            * Triggered when: SqPaymentForm is fully loaded
            */
          paymentFormLoaded () {
            /* HANDLE AS DESIRED */
          }
        }
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style >
.cardfields input {
   width: 100%;
   height: 50px;
   border-radius: 5px;
   -webkit-box-shadow: none;
   box-shadow: none;
   border: 1px solid #ced6e0;
   -webkit-transition: all 0.3s ease-in-out;
   transition: all 0.3s ease-in-out;
   font-size: 18px;
   padding: 5px 15px;
   background: none;
   color: #1a3b5d;
}
.vs-input--view.custome-padding {
    padding: 1rem !important;
}
.sq-input {
   width: 100%;
   height: 46px;
   border-radius: 5px;
   -webkit-box-shadow: none;
   box-shadow: none;
   border: 1px solid rgba(0, 0, 0, 0.2) !important;
   -webkit-transition: all 0.3s ease-in-out;
   transition: all 0.3s ease-in-out;
   font-size: 18px;
   padding: .9rem !important;
   margin-bottom: 20px;
   background: none;
   color: #1a3b5d;
}

.sq-input ::placeholder {
  color: #aab7c4;
  opacity: 0.5;
}

/* Define how SqPaymentForm iframes should look when they have focus */

/* Define how SqPaymentForm iframes should look when they contain invalid values */

.sq-input--error {
  outline: 3px auto rgb(255, 97, 97);
}

.errorbox {
  line-height: 14px;
  text-align: left;
}

.error {
  font-size: 10px;
  color: rgb(164, 0, 30);
  width: 45%;
  display: inline-block;

  margin-top: -10px;
  font-weight: 400;
}

/* Customize the "Pay with Credit Card" button */

.button-credit-card {
  min-width: 200px;
  min-height: 20px;
  padding: 0;
  margin: 5px;
  line-height: 20px;
  box-shadow: 2px 2px 1px rgb(200, 200, 200);
  background: rgb(255, 255, 255);
  border-radius: 5px;
  border: 1px solid rgb(200, 200, 200);
  font-weight: bold;
  cursor: pointer;
}

.card-number {
  width: 100%;
}

.modal .payButton {
  margin-left: 0px;
  position: absolute;
  bottom: 0px;
  width: 400px;
}

/* Customize the "{{Wallet}} not enabled" message */

.wallet-not-enabled {
  min-width: 200px;
  min-height: 40px;
  max-height: 64px;
  padding: 0;
  margin: 10px;
  line-height: 40px;
  background: #eee;
  border-radius: 5px;
  font-weight: lighter;
  font-style: italic;
  font-family: inherit;
  display: block;
}

/* Customize the Apple Pay on the Web button */

.button-apple-pay {
  min-width: 200px;
  min-height: 40px;
  max-height: 64px;
  padding: 0;
  margin: 10px;
  background-image: -webkit-named-image(apple-pay-logo-white);
  background-color: black;
  background-size: 100% 60%;
  background-repeat: no-repeat;
  background-position: 50% 50%;
  border-radius: 5px;
  cursor: pointer;
  display: none;
}

/* Customize the Masterpass button */

.button-masterpass {
  min-width: 200px;
  min-height: 40px;
  max-height: 40px;
  padding: 0;
  margin: 10px;
  background-image: url(https://static.masterpass.com/dyn/img/btn/global/mp_chk_btn_147x034px.svg);
  background-color: black;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  background-position: 50% 50%;
  border-radius: 5px;
  border-color: rgb(255, 255, 255);
  cursor: pointer;
}

#sq-walletbox {
  text-align: center;
  vertical-align: top;
  font-weight: bold;
}

.expiration-date,
.cvv,
.postal-code {
  width: 30%;
  display: inline-block;
}

.expiration-date, .cvv  {
    margin-right: 25px;
}
.payButton {
    width: 100%;
    height: 48px;
    background: #7367f0;
    border: none;
    border-radius: 5px;
    font-size: 18px;
    font-weight: 500;
    font-family: "Source Sans Pro", sans-serif;
    -webkit-box-shadow: 3px 10px 20px 0px rgba(35, 100, 210, 0.3);
    box-shadow: 3px 10px 20px 0px rgba(35, 100, 210, 0.3);
    color: #fff;
    margin-top: 20px;
    cursor: pointer;
}
</style>
